import PositioningDeviceFittingDetailModal from './positioning-device-fitting-detail-modal.vue'
export default PositioningDeviceFittingDetailModal
